export function formatIdAttribute(idString) {
	const formattedIdString = idString
		.replace(/[.'’?!,:;]/g, "") // Remove special characters
		.replace(/ /g, "-"); // Replace spaces with hyphens
	return formattedIdString.toLowerCase(); // Convert to lowercase
}
